var $ = window.jQuery;
import productAccommodation from './shared/product-accommodation'

export default {
  loaded() {
    productAccommodation()
  }
}
